import initial from './001_initial';
import { IMigration } from './MigrationTypes';

export const migrations: IMigration[] = [initial];
